import { waLink } from "../../data";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const FloatingWhatsApp = () => (
  <a
    href={waLink("Halo Javanese Spa Jogja, saya ingin booking Massage panggilan.")}
    target="_blank"
    rel="noreferrer"
    data-testid="floating-whatsapp-btn"
    className="fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-[#25D366] text-white pl-4 pr-5 py-3 shadow-[0_10px_30px_rgba(37,211,102,0.4)] hover:scale-105 active:scale-95 transition-transform"
  >
    <WhatsAppIcon className="h-6 w-6" />
    <span className="text-sm font-medium hidden sm:inline">Booking WhatsApp</span>
  </a>
);
